import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="12" cy="12" r="12" fill="#243E81"/> <circle cx="12" cy="12" r="12" fill="#fff" fill-opacity=".5"/> <path fill="#fff" d="M8.285 9.335a1.689 1.689 0 1 0 0-3.378 1.689 1.689 0 0 0 0 3.378m7.426 0a1.689 1.689 0 1 0 0-3.378 1.689 1.689 0 0 0 0 3.378m-6.834.83H7.693a2.376 2.376 0 0 0-2.377 2.376v5.502h5.941V12.54h-.004a2.376 2.376 0 0 0-2.376-2.376m7.426 0h-1.184a2.376 2.376 0 0 0-2.376 2.376v5.502h5.94V12.54h-.004a2.376 2.376 0 0 0-2.376-2.376"/>' }
  })
);